import { Component } from "@angular/core";

@Component({
    selector: 'ui-button-group',
    templateUrl: 'ui-button-group.component.html'
})
export class UIButtonGroupComponent {
    
}